import { createContext, FC, ReactNode, useContext, useMemo, useState } from 'react';
import { AttioValuationFormattedResponse } from 'dashboard409a/services/attio.types';

interface AttioValuationContextType {
  currentAttioValuation: AttioValuationFormattedResponse | null;
  setCurrentAttioValuation: (valuation: AttioValuationFormattedResponse | null) => void;
  currentAttioCompanyName: string | null;
  setCurrentAttioCompanyName: (name: string | null) => void;
}

const AttioValuationContext = createContext<AttioValuationContextType>({
  currentAttioValuation: null,
  setCurrentAttioValuation: () => {},
  currentAttioCompanyName: null,
  setCurrentAttioCompanyName: () => {},
});

interface AttioValuationProviderProps {
  children: ReactNode;
}

const AttioValuationProvider: FC<AttioValuationProviderProps> = ({ children }) => {
  const [currentAttioValuation, setCurrentAttioValuation] = useState<AttioValuationFormattedResponse | null>(null);
  const [currentAttioCompanyName, setCurrentAttioCompanyName] = useState<string | null>(null);

  const contextValue: AttioValuationContextType = useMemo(
    () => ({
      currentAttioValuation,
      setCurrentAttioValuation,
      currentAttioCompanyName,
      setCurrentAttioCompanyName,
    }),
    [currentAttioValuation, currentAttioCompanyName]
  );

  return <AttioValuationContext.Provider value={contextValue}>{children}</AttioValuationContext.Provider>;
};


const useAttioValuationContext = () => {
  const context = useContext(AttioValuationContext);
  if (!context) {
    throw new Error('useAttioValuationContext must be used within an AttioValuationProvider');
  }
  return context;
};

export { AttioValuationProvider, useAttioValuationContext };
export type { AttioValuationContextType };
export default AttioValuationContext;
